import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isModernPullRequestExperienceEnabled(): boolean {
  return isFeatureEnabled('prs_overview_as_index_route')
}
